import React from 'react';
import { CheckCircle } from 'lucide-react';
import { Button } from '../ui/button';

/**
 * ClaimSuccessCard — post-account-claim success card with dual CTAs.
 * Pure presentational.
 */
export default function ClaimSuccessCard({ onGoToMyPasses, onViewThisPass }) {
  return (
    <div className="bg-[#0A0A0A] border border-[#D4AF37]/20 rounded-sm p-6" data-testid="claim-success-section">
      <div className="text-center mb-6">
        <div className="w-16 h-16 rounded-full bg-emerald-500/10 flex items-center justify-center mx-auto mb-3">
          <CheckCircle className="w-8 h-8 text-emerald-400" />
        </div>
        <h3 className="text-xl font-bold text-[#EAE7E1]">You're All Set!</h3>
        <p className="text-sm text-[#AFAFAF] mt-1">Your VelvetGate account is ready.</p>
        <p className="text-xs text-[#777] mt-1">Your passes live in <span className="text-[#D4AF37] font-semibold">My Passes</span> — sign in anytime with your email to view or download them.</p>
      </div>

      <div className="space-y-3">
        <Button
          onClick={onGoToMyPasses}
          className="w-full bg-gradient-to-r from-[#8C6B1F] via-[#D4AF37] to-[#F2D27A] hover:opacity-90 text-[#050505] rounded-sm px-6 py-4 font-bold text-base"
          data-testid="go-to-my-passes-button"
        >
          Go to My Passes
        </Button>
        <Button
          onClick={onViewThisPass}
          variant="outline"
          className="w-full border-[#1A1A1A] text-[#AFAFAF] hover:text-[#EAE7E1] hover:bg-[#1A1A1A] rounded-sm px-6 py-4"
          data-testid="view-this-pass-button"
        >
          View This Pass
        </Button>
      </div>
    </div>
  );
}
